const FavoriteIcon = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Favorite Meal</title>
    <path
      d="M0 12C0 5.37258 5.37258 0 12 0V0C18.6274 0 24 5.37258 24 12V12C24 18.6274 18.6274 24 12 24V24C5.37258 24 0 18.6274 0 12V12Z"
      fill="#D92236"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.8876 6.37862C13.7956 6.42927 12.8122 7.00888 12.0998 7.99969L12 8.14394C11.249 7.01738 10.1644 6.37625 8.96 6.37625C6.91495 6.37625 5.125 8.13294 5.125 10.4631C5.125 12.2454 6.11948 13.6588 8.08653 15.3168L8.42654 15.5983C8.61137 15.749 8.80029 15.8994 9.13533 16.1645L9.50927 16.4579C10.0972 16.915 10.5245 17.2252 11.0235 17.5664L11.6427 17.9862C11.8593 18.1352 12.1461 18.1327 12.3601 17.9798L13.2197 17.3788C13.7273 17.0208 14.1844 16.6843 14.8644 16.1648C17.6039 14.0728 18.875 12.5367 18.875 10.4356C18.875 8.11953 17.0864 6.375 15.0444 6.375L14.8876 6.37862Z"
      fill="white"
    />
  </svg>
);

FavoriteIcon.propTypes = {
  className: PropTypes.string,
};

export default FavoriteIcon;
